import { render, staticRenderFns } from "./NYCXDiscountByItemCodeTable.vue?vue&type=template&id=777ab1e0"
import script from "./NYCXDiscountByItemCodeTable.vue?vue&type=script&lang=ts"
export * from "./NYCXDiscountByItemCodeTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports